import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import { useSetState } from "Helpers/Hooks";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { setFactorSetting } from "Stores/actions";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import { ExpandMore } from "@material-ui/icons";

export default function FactorPreviewSetting({ factorModal }) {
  const { t } = useTranslation();
  const { factorSetting } = useSelector((state) => ({
    factorSetting: state.factor.factorSetting,
  }));
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setExpanded("Setting");
    }, 200);
  }, []);

  const [controls, setControls] = useSetState({
    TypeViewFactor: {
      type: "radio",
      value: { value: 1, key: "ProfileStructure" },
      items: [
        { value: 1, key: "ProfileStructure" },
        { value: 2, key: "MeterLong" },
        { value: 3, key: "Weighty" },
      ],
    },
    invoiceTitle: {
      type: "radio",
      value: { value: 1, key: "invoiceTitlePre" },
      items: [
        { value: 1, key: "invoiceTitlePre" },
        { value: 2, key: "invoiceTitleMain" },
      ],
    },
    TypeFactor: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    IsWaterMark: {
      type: "checkbox",
      items: [{ value: false, key: "IsWaterMark" }],
    },
    IsIncOtherProfileToMetrajhUnitBUnit: {
      type: "checkbox",
      items: [{ value: false, key: "IsIncOtherProfileToMetrajhUnitBUnit" }],
    },
  });

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
    if (name === "invoiceTitle") {
      const result = {
        ...factorSetting,
        IsFactor: value.value === 1 ? false : true,
      };
      dispatch(setFactorSetting(result));
    } else {
      const result = {
        ...factorSetting,
        [name]: value.value,
      };
      dispatch(setFactorSetting(result));
    }
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });

    const IsIncOtherProfileToMetrajhUnitBUnit = [3, 12, 13, 14, 15].includes(value.value)
      ? factorSetting.IsIncOtherProfileToMetrajhUnitBUnit
      : false;

    const result = {
      ...factorSetting,
      [controlName]: value.value,
      IsIncOtherProfileToMetrajhUnitBUnit,
    };
    dispatch(setFactorSetting(result));
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
    const key = items[index].key;
    const result = {
      ...factorSetting,
      [key]: e.currentTarget.checked,
    };
    dispatch(setFactorSetting(result));
  };

  useEffect(() => {
    (async () => {
      if (factorModal.length > 0) {
        try {
          setControls({ TypeFactor: { selectItems: factorModal } });
          if (factorSetting.TypeFactor) {
            const selectedType = factorModal.filter(
              (item) => item.value === factorSetting.TypeFactor
            );
            setControls({ TypeFactor: { value: selectedType[0] } });
          } else {
            const selectedType = factorModal.filter((item) => item.value === 1);
            setControls({ TypeFactor: { value: selectedType[0] } });
            const result = {
              ...factorSetting,
              TypeFactor: 1,
            };
            dispatch(setFactorSetting(result));
          }
        } catch (err) {
          console.error("[catch error]", err);
        }
      }
    })();
  }, [factorModal]);

  useEffect(() => {
    if (factorSetting.TypeViewFactor)
      setControls({
        TypeViewFactor: {
          value:
            controls.TypeViewFactor.items[+factorSetting.TypeViewFactor - 1],
        },
      });
    if (factorSetting.IsFactor)
      setControls({
        invoiceTitle: {
          value: factorSetting.IsFactor
            ? controls.invoiceTitle.items[1]
            : controls.invoiceTitle.items[0],
        },
      });
    if (factorSetting.IsWaterMark) {
      const items = controls.IsWaterMark.items;
      items[0] = { ...items[0], value: factorSetting.IsWaterMark };
      setControls({ IsWaterMark: { items } });
    }
  }, []);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Accordion
      className="border-0 shadow-none"
      expanded={expanded === "Setting"}
      onChange={handleChange("Setting")}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Icons.Sliders size={18} />
        <p>{t("factorDisplaySetting")}</p>
      </AccordionSummary>
      <AccordionDetails className="p-0">
        <Grid container spacing={2}>
          <Grid item>
            <MuiRadioGroup
              // label={<Translator id={'invoiceTitle'}/>}
              name="invoiceTitle"
              value={controls.invoiceTitle.value}
              items={controls.invoiceTitle.items}
              translate={true}
              onChange={onChangeRadio}
              className="horizontalRadio"
            />
          </Grid>
          <Grid item>
            <MuiRadioGroup
              // label={<Translator id={'invoiceTitle'}/>}
              name="TypeViewFactor"
              value={controls.TypeViewFactor.value}
              items={controls.TypeViewFactor.items}
              translate={true}
              onChange={onChangeRadio}
              className="horizontalRadio"
            />
          </Grid>
          <Grid item>
            <MuiCheckBoxGroup
              label=""
              name={"IsWaterMark"}
              value={controls.IsWaterMark.value}
              items={controls.IsWaterMark.items}
              onChange={onChangeCheckbox}
              translate={true}
              className="horizontalCheckbox"
            />
          </Grid>
          <Grid item md={3} sm={4} xs={12} style={{ minWidth: "200px" }}>
            <MuiAutoComplete
              options={controls.TypeFactor.selectItems}
              value={controls.TypeFactor.value}
              id="TypeFactor"
              onChange={autoCompleteHandler}
            />
          </Grid>
          {factorSetting.TypeFactor &&
            [3, 12, 13, 14, 15].includes(factorSetting.TypeFactor) && (
              <Grid item>
                <MuiCheckBoxGroup
                  label=""
                  name={"IsIncOtherProfileToMetrajhUnitBUnit"}
                  value={controls.IsIncOtherProfileToMetrajhUnitBUnit.value}
                  items={controls.IsIncOtherProfileToMetrajhUnitBUnit.items}
                  onChange={onChangeCheckbox}
                  translate={true}
                  className="horizontalCheckbox"
                />
              </Grid>
            )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
